import { DEFAULT_INTERNAL_TRANSFER_FEE_PIPS } from '../model/system-transaction-settings.model.js';

function normalizeInteger(value, fallback = 0) {
  const number = Number(value);
  return Number.isInteger(number) ? number : fallback;
}

export function mapInternalTransferSettingsResponseToDto(payload) {
  const hasSavedFeePips = payload?.feePips !== undefined && payload?.feePips !== null;
  const feePips = normalizeInteger(payload?.feePips, DEFAULT_INTERNAL_TRANSFER_FEE_PIPS);

  return {
    feePips: String(feePips),
    defaultFeePips: normalizeInteger(payload?.defaultFeePips, DEFAULT_INTERNAL_TRANSFER_FEE_PIPS),
    usingDefaultFeePips: payload?.usingDefaultFeePips !== undefined
      ? Boolean(payload.usingDefaultFeePips)
      : !hasSavedFeePips,
  };
}

export function buildInternalTransferSettingsPayloadFromForm(form) {
  const feePipsRaw = String(form?.feePips || '').trim();

  return {
    feePips: Number(feePipsRaw),
    feePipsRaw,
  };
}

export function validateInternalTransferSettingsPayload(payload) {
  const errors = {};

  if (!payload.feePipsRaw) {
    errors.feePips = 'This field is required.';
  } else if (!Number.isInteger(payload.feePips) || payload.feePips < 0) {
    errors.feePips = 'Fee must be zero or a positive integer.';
  }

  return errors;
}

export function mapInternalTransferSettingsFieldErrors(requestError) {
  const errors = {};
  const details = Array.isArray(requestError?.errors) ? requestError.errors : [];

  details.forEach((item) => {
    const parameter = String(item?.parameter || '').trim();
    if (parameter === 'feePips') {
      errors.feePips = String(item?.message || 'Invalid value').trim() || 'Invalid value';
    }
  });

  return errors;
}
